import { inWindow } from 'api';
import React from 'react';
export default ({ children }) => (inWindow() ? React.createElement("div", null, children) : null);
